/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_syl_stat_characters = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Characters`)
};

const es_syl_stat_characters = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caracteres`)
};

const de_syl_stat_characters = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeichen`)
};

const nl_syl_stat_characters = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekens`)
};

const fr_syl_stat_characters = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caractères`)
};

const it_syl_stat_characters = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caratteri`)
};

const pt_br2_syl_stat_characters = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caracteres`)
};

const pt_syl_stat_characters = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caracteres`)
};

const ja_syl_stat_characters = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文字数`)
};

const zh_syl_stat_characters = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字符数`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const syl_stat_characters = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.syl_stat_characters(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("syl_stat_characters", locale)
	if (locale === "en") return en_syl_stat_characters(inputs)
	if (locale === "es") return es_syl_stat_characters(inputs)
	if (locale === "de") return de_syl_stat_characters(inputs)
	if (locale === "nl") return nl_syl_stat_characters(inputs)
	if (locale === "fr") return fr_syl_stat_characters(inputs)
	if (locale === "it") return it_syl_stat_characters(inputs)
	if (locale === "pt-BR") return pt_br2_syl_stat_characters(inputs)
	if (locale === "pt") return pt_syl_stat_characters(inputs)
	if (locale === "ja") return ja_syl_stat_characters(inputs)
	return zh_syl_stat_characters(inputs)
};